import { Provider, ProviderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useAddProviderUser = () =>
  useMutationWithLoading(async (param: Provider & { xTENANTID?: string }) =>
    new ProviderControllerApi(getConfigObject()).createProvider(
      param,
      param.xTENANTID
    )
  );

  export const useAddReferralProvider = () =>
    useMutationWithLoading(async (param: { providerData: Provider; xTENANTID?: string }) =>
      new ProviderControllerApi(getConfigObject()).createProvider(
        param.providerData,
        param.xTENANTID
      )
    );